// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4f6664f6","455":"96653016","977":"5ca071f4"}[chunkId] + ".chunk.js";
};